import { ReactNode } from 'react';

interface PersonsGridProps {
  children: ReactNode;
}

export const PersonsGrid = ({ children }: PersonsGridProps) => {
  return (
    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 pb-12">
      {children}
    </div>
  );
};